module.exports = __webpack_public_path__ + "static/media/Gallery 4.8b4e823d.svg";